var _excluded = ["data"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import mutate from "dom-mutator";
import { decrypt, getAutoExperimentChangeType, isURLTargeted, loadSDKVersion, mergeQueryStrings, promiseTimeout } from "./util.mjs";
import { configureCache, refreshFeatures, startStreaming, unsubscribe } from "./feature-repository.mjs";
import { runExperiment, evalFeature as _evalFeature, getExperimentResult, getAllStickyBucketAssignmentDocs, decryptPayload, getApiHosts as _getApiHosts } from "./core.mjs";
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var SDK_VERSION = loadSDKVersion();
export var GrowthBook = /*#__PURE__*/function () {
  // context is technically private, but some tools depend on it so we can't mangle the name

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  // eslint-disable-next-line

  function GrowthBook(options) {
    _classCallCheck(this, GrowthBook);
    options = options || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this.version = SDK_VERSION;
    this._options = this.context = options;
    this._renderer = options.renderer || null;
    this._trackedExperiments = new Set();
    this._completedChangeIds = new Set();
    this._trackedFeatures = {};
    this.debug = !!options.debug;
    this._subscriptions = new Set();
    this.ready = false;
    this._assigned = new Map();
    this._attributeOverrides = {};
    this._activeAutoExperiments = new Map();
    this._triggeredExpKeys = new Set();
    this._initialized = false;
    this._redirectedUrl = "";
    this._deferredTrackingCalls = new Map();
    this._autoExperimentsAllowed = !options.disableExperimentsOnLoad;
    this._destroyCallbacks = [];
    this.logs = [];
    this.log = this.log.bind(this);
    this._track = this._track.bind(this);
    this._saveDeferredTrack = this._saveDeferredTrack.bind(this);
    this._trackFeatureUsage = this._trackFeatureUsage.bind(this);
    this._fireSubscriptions = this._fireSubscriptions.bind(this);
    this._recordChangedId = this._recordChangedId.bind(this);
    if (options.remoteEval) {
      if (options.decryptionKey) {
        throw new Error("Encryption is not available for remoteEval");
      }
      if (!options.clientKey) {
        throw new Error("Missing clientKey");
      }
      var isGbHost = false;
      try {
        isGbHost = !!new URL(options.apiHost || "").hostname.match(/growthbook\.io$/i);
      } catch (e) {
        // ignore invalid URLs
      }
      if (isGbHost) {
        throw new Error("Cannot use remoteEval on GrowthBook Cloud");
      }
    } else {
      if (options.cacheKeyAttributes) {
        throw new Error("cacheKeyAttributes are only used for remoteEval");
      }
    }
    if (options.stickyBucketService) {
      var s = options.stickyBucketService;
      this._saveStickyBucketAssignmentDoc = function (doc) {
        return s.saveAssignments(doc);
      };
    }
    if (options.plugins) {
      var _iterator = _createForOfIteratorHelper(options.plugins),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin(this);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (options.features) {
      this.ready = true;
    }
    if (isBrowser && options.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (options.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    // Hydrate sticky bucket service
    if (this._options.stickyBucketService && this._options.stickyBucketAssignmentDocs) {
      for (var key in this._options.stickyBucketAssignmentDocs) {
        var doc = this._options.stickyBucketAssignmentDocs[key];
        if (doc) {
          this._options.stickyBucketService.saveAssignments(doc).catch(function () {
            // Ignore hydration errors
          });
        }
      }
    }

    // Legacy - passing in features/experiments into the constructor instead of using init
    if (this.ready) {
      this.refreshStickyBuckets(this.getPayload());
    }
  }
  return _createClass(GrowthBook, [{
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._payload = payload;
              _context.next = 3;
              return decryptPayload(payload, this._options.decryptionKey);
            case 3:
              data = _context.sent;
              this._decryptedPayload = data;
              _context.next = 7;
              return this.refreshStickyBuckets(data);
            case 7:
              if (data.features) {
                this._options.features = data.features;
              }
              if (data.savedGroups) {
                this._options.savedGroups = data.savedGroups;
              }
              if (data.experiments) {
                this._options.experiments = data.experiments;
                this._updateAllAutoExperiments();
              }
              this.ready = true;
              this._render();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setPayload(_x) {
        return _setPayload.apply(this, arguments);
      }
      return setPayload;
    }()
  }, {
    key: "initSync",
    value: function initSync(options) {
      this._initialized = true;
      var payload = options.payload;
      if (payload.encryptedExperiments || payload.encryptedFeatures) {
        throw new Error("initSync does not support encrypted payloads");
      }
      if (this._options.stickyBucketService && !this._options.stickyBucketAssignmentDocs) {
        throw new Error("initSync requires you to pass stickyBucketAssignmentDocs into the GrowthBook constructor");
      }
      this._payload = payload;
      this._decryptedPayload = payload;
      if (payload.features) {
        this._options.features = payload.features;
      }
      if (payload.experiments) {
        this._options.experiments = payload.experiments;
        this._updateAllAutoExperiments();
      }
      this.ready = true;
      startStreaming(this, options);
      return this;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        var _yield$this$_refresh, data, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this._initialized = true;
              options = options || {};
              if (options.cacheSettings) {
                configureCache(options.cacheSettings);
              }
              if (!options.payload) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return this.setPayload(options.payload);
            case 6:
              startStreaming(this, options);
              return _context2.abrupt("return", {
                success: true,
                source: "init"
              });
            case 10:
              _context2.next = 12;
              return this._refresh(_objectSpread(_objectSpread({}, options), {}, {
                allowStale: true
              }));
            case 12:
              _yield$this$_refresh = _context2.sent;
              data = _yield$this$_refresh.data;
              res = _objectWithoutProperties(_yield$this$_refresh, _excluded);
              startStreaming(this, options);
              _context2.next = 18;
              return this.setPayload(data || {});
            case 18:
              return _context2.abrupt("return", res);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init(_x2) {
        return _init.apply(this, arguments);
      }
      return init;
    }() /** @deprecated Use {@link init} */
  }, {
    key: "loadFeatures",
    value: (function () {
      var _loadFeatures = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
        var _this$_options$backgr;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              options = options || {};
              _context3.next = 3;
              return this.init({
                skipCache: options.skipCache,
                timeout: options.timeout,
                streaming: ((_this$_options$backgr = this._options.backgroundSync) !== null && _this$_options$backgr !== void 0 ? _this$_options$backgr : true) && (options.autoRefresh || this._options.subscribeToChanges)
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadFeatures(_x3) {
        return _loadFeatures.apply(this, arguments);
      }
      return loadFeatures;
    }())
  }, {
    key: "refreshFeatures",
    value: function () {
      var _refreshFeatures = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this._refresh(_objectSpread(_objectSpread({}, options || {}), {}, {
                allowStale: false
              }));
            case 2:
              res = _context4.sent;
              if (!res.data) {
                _context4.next = 6;
                break;
              }
              _context4.next = 6;
              return this.setPayload(res.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function refreshFeatures(_x4) {
        return _refreshFeatures.apply(this, arguments);
      }
      return refreshFeatures;
    }()
  }, {
    key: "getApiInfo",
    value: function getApiInfo() {
      return [this.getApiHosts().apiHost, this.getClientKey()];
    }
  }, {
    key: "getApiHosts",
    value: function getApiHosts() {
      return _getApiHosts(this._options);
    }
  }, {
    key: "getClientKey",
    value: function getClientKey() {
      return this._options.clientKey || "";
    }
  }, {
    key: "getPayload",
    value: function getPayload() {
      return this._payload || {
        features: this.getFeatures(),
        experiments: this.getExperiments()
      };
    }
  }, {
    key: "getDecryptedPayload",
    value: function getDecryptedPayload() {
      return this._decryptedPayload || this.getPayload();
    }
  }, {
    key: "isRemoteEval",
    value: function isRemoteEval() {
      return this._options.remoteEval || false;
    }
  }, {
    key: "getCacheKeyAttributes",
    value: function getCacheKeyAttributes() {
      return this._options.cacheKeyAttributes;
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref) {
        var _ref2;
        var timeout, skipCache, allowStale, streaming;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              timeout = _ref.timeout, skipCache = _ref.skipCache, allowStale = _ref.allowStale, streaming = _ref.streaming;
              if (this._options.clientKey) {
                _context5.next = 3;
                break;
              }
              throw new Error("Missing clientKey");
            case 3:
              return _context5.abrupt("return", refreshFeatures({
                instance: this,
                timeout: timeout,
                skipCache: skipCache || this._options.disableCache,
                allowStale: allowStale,
                backgroundSync: (_ref2 = streaming !== null && streaming !== void 0 ? streaming : this._options.backgroundSync) !== null && _ref2 !== void 0 ? _ref2 : true
              }));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function _refresh(_x5) {
        return _refresh2.apply(this, arguments);
      }
      return _refresh;
    }()
  }, {
    key: "_render",
    value: function _render() {
      if (this._renderer) {
        try {
          this._renderer();
        } catch (e) {
          console.error("Failed to render", e);
        }
      }
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setFeatures",
    value: function setFeatures(features) {
      this._options.features = features;
      this.ready = true;
      this._render();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedFeatures",
    value: (function () {
      var _setEncryptedFeatures = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(encryptedString, decryptionKey, subtle) {
        var featuresJSON;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 2:
              featuresJSON = _context6.sent;
              this.setFeatures(JSON.parse(featuresJSON));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function setEncryptedFeatures(_x6, _x7, _x8) {
        return _setEncryptedFeatures.apply(this, arguments);
      }
      return setEncryptedFeatures;
    }() /** @deprecated Use {@link setPayload} */)
  }, {
    key: "setExperiments",
    value: function setExperiments(experiments) {
      this._options.experiments = experiments;
      this.ready = true;
      this._updateAllAutoExperiments();
    }

    /** @deprecated Use {@link setPayload} */
  }, {
    key: "setEncryptedExperiments",
    value: (function () {
      var _setEncryptedExperiments = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(encryptedString, decryptionKey, subtle) {
        var experimentsJSON;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return decrypt(encryptedString, decryptionKey || this._options.decryptionKey, subtle);
            case 2:
              experimentsJSON = _context7.sent;
              this.setExperiments(JSON.parse(experimentsJSON));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setEncryptedExperiments(_x9, _x10, _x11) {
        return _setEncryptedExperiments.apply(this, arguments);
      }
      return setEncryptedExperiments;
    }())
  }, {
    key: "setAttributes",
    value: function () {
      var _setAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(attributes) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this._options.attributes = attributes;
              if (!this._options.stickyBucketService) {
                _context8.next = 4;
                break;
              }
              _context8.next = 4;
              return this.refreshStickyBuckets();
            case 4:
              if (!this._options.remoteEval) {
                _context8.next = 8;
                break;
              }
              _context8.next = 7;
              return this._refreshForRemoteEval();
            case 7:
              return _context8.abrupt("return");
            case 8:
              this._render();
              this._updateAllAutoExperiments();
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function setAttributes(_x12) {
        return _setAttributes.apply(this, arguments);
      }
      return setAttributes;
    }()
  }, {
    key: "updateAttributes",
    value: function () {
      var _updateAttributes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(attributes) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.setAttributes(_objectSpread(_objectSpread({}, this._options.attributes), attributes)));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function updateAttributes(_x13) {
        return _updateAttributes.apply(this, arguments);
      }
      return updateAttributes;
    }()
  }, {
    key: "setAttributeOverrides",
    value: function () {
      var _setAttributeOverrides = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(overrides) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this._attributeOverrides = overrides;
              if (!this._options.stickyBucketService) {
                _context10.next = 4;
                break;
              }
              _context10.next = 4;
              return this.refreshStickyBuckets();
            case 4:
              if (!this._options.remoteEval) {
                _context10.next = 8;
                break;
              }
              _context10.next = 7;
              return this._refreshForRemoteEval();
            case 7:
              return _context10.abrupt("return");
            case 8:
              this._render();
              this._updateAllAutoExperiments();
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function setAttributeOverrides(_x14) {
        return _setAttributeOverrides.apply(this, arguments);
      }
      return setAttributeOverrides;
    }()
  }, {
    key: "setForcedVariations",
    value: function () {
      var _setForcedVariations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(vars) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this._options.forcedVariations = vars || {};
              if (!this._options.remoteEval) {
                _context11.next = 5;
                break;
              }
              _context11.next = 4;
              return this._refreshForRemoteEval();
            case 4:
              return _context11.abrupt("return");
            case 5:
              this._render();
              this._updateAllAutoExperiments();
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function setForcedVariations(_x15) {
        return _setForcedVariations.apply(this, arguments);
      }
      return setForcedVariations;
    }() // eslint-disable-next-line
  }, {
    key: "setForcedFeatures",
    value: function setForcedFeatures(map) {
      this._forcedFeatureValues = map;
      this._render();
    }
  }, {
    key: "setURL",
    value: function () {
      var _setURL = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(url) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!(url === this._options.url)) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return");
            case 2:
              this._options.url = url;
              this._redirectedUrl = "";
              if (!this._options.remoteEval) {
                _context12.next = 9;
                break;
              }
              _context12.next = 7;
              return this._refreshForRemoteEval();
            case 7:
              this._updateAllAutoExperiments(true);
              return _context12.abrupt("return");
            case 9:
              this._updateAllAutoExperiments(true);
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function setURL(_x16) {
        return _setURL.apply(this, arguments);
      }
      return setURL;
    }()
  }, {
    key: "getAttributes",
    value: function getAttributes() {
      return _objectSpread(_objectSpread({}, this._options.attributes), this._attributeOverrides);
    }
  }, {
    key: "getForcedVariations",
    value: function getForcedVariations() {
      return this._options.forcedVariations || {};
    }
  }, {
    key: "getForcedFeatures",
    value: function getForcedFeatures() {
      // eslint-disable-next-line
      return this._forcedFeatureValues || new Map();
    }
  }, {
    key: "getStickyBucketAssignmentDocs",
    value: function getStickyBucketAssignmentDocs() {
      return this._options.stickyBucketAssignmentDocs || {};
    }
  }, {
    key: "getUrl",
    value: function getUrl() {
      return this._options.url || "";
    }
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      return this._options.features || {};
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      return this._options.experiments || [];
    }
  }, {
    key: "getCompletedChangeIds",
    value: function getCompletedChangeIds() {
      return Array.from(this._completedChangeIds);
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      var _this = this;
      this._subscriptions.add(cb);
      return function () {
        _this._subscriptions.delete(cb);
      };
    }
  }, {
    key: "_refreshForRemoteEval",
    value: function () {
      var _refreshForRemoteEval2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var res;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this._options.remoteEval) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              if (this._initialized) {
                _context13.next = 4;
                break;
              }
              return _context13.abrupt("return");
            case 4:
              _context13.next = 6;
              return this._refresh({
                allowStale: false
              });
            case 6:
              res = _context13.sent;
              if (!res.data) {
                _context13.next = 10;
                break;
              }
              _context13.next = 10;
              return this.setPayload(res.data);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function _refreshForRemoteEval() {
        return _refreshForRemoteEval2.apply(this, arguments);
      }
      return _refreshForRemoteEval;
    }()
  }, {
    key: "getAllResults",
    value: function getAllResults() {
      return new Map(this._assigned);
    }
  }, {
    key: "onDestroy",
    value: function onDestroy(cb) {
      this._destroyCallbacks.push(cb);
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return !!this._destroyed;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._destroyed = true;

      // Custom callbacks
      // Do this first in case it needs access to the below data that is cleared
      this._destroyCallbacks.forEach(function (cb) {
        try {
          cb();
        } catch (e) {
          console.error(e);
        }
      });

      // Release references to save memory
      this._subscriptions.clear();
      this._assigned.clear();
      this._trackedExperiments.clear();
      this._completedChangeIds.clear();
      this._deferredTrackingCalls.clear();
      this._trackedFeatures = {};
      this._destroyCallbacks = [];
      this._payload = undefined;
      this._saveStickyBucketAssignmentDoc = undefined;
      unsubscribe(this);
      this.logs = [];
      if (isBrowser && window._growthbook === this) {
        delete window._growthbook;
      }

      // Undo any active auto experiments
      this._activeAutoExperiments.forEach(function (exp) {
        exp.undo();
      });
      this._activeAutoExperiments.clear();
      this._triggeredExpKeys.clear();
    }
  }, {
    key: "setRenderer",
    value: function setRenderer(renderer) {
      this._renderer = renderer;
    }
  }, {
    key: "forceVariation",
    value: function forceVariation(key, variation) {
      this._options.forcedVariations = this._options.forcedVariations || {};
      this._options.forcedVariations[key] = variation;
      if (this._options.remoteEval) {
        this._refreshForRemoteEval();
        return;
      }
      this._updateAllAutoExperiments();
      this._render();
    }
  }, {
    key: "run",
    value: function run(experiment) {
      var _runExperiment = runExperiment(experiment, null, this._getEvalContext()),
        result = _runExperiment.result;
      this._fireSubscriptions(experiment, result);
      return result;
    }
  }, {
    key: "triggerExperiment",
    value: function triggerExperiment(key) {
      var _this2 = this;
      this._triggeredExpKeys.add(key);
      if (!this._options.experiments) return null;
      var experiments = this._options.experiments.filter(function (exp) {
        return exp.key === key;
      });
      return experiments.map(function (exp) {
        return _this2._runAutoExperiment(exp);
      }).filter(function (res) {
        return res !== null;
      });
    }
  }, {
    key: "triggerAutoExperiments",
    value: function triggerAutoExperiments() {
      this._autoExperimentsAllowed = true;
      this._updateAllAutoExperiments(true);
    }
  }, {
    key: "_getEvalContext",
    value: function _getEvalContext() {
      return {
        user: this._getUserContext(),
        global: this._getGlobalContext(),
        stack: {
          evaluatedFeatures: new Set()
        }
      };
    }
  }, {
    key: "_getUserContext",
    value: function _getUserContext() {
      return {
        attributes: this._options.user ? _objectSpread(_objectSpread({}, this._options.user), this.getAttributes()) : this.getAttributes(),
        blockedChangeIds: this._options.blockedChangeIds,
        stickyBucketAssignmentDocs: this._options.stickyBucketAssignmentDocs,
        url: this._getContextUrl(),
        forcedVariations: this._options.forcedVariations,
        forcedFeatureValues: this._forcedFeatureValues,
        saveStickyBucketAssignmentDoc: this._saveStickyBucketAssignmentDoc,
        trackingCallback: this._options.trackingCallback ? this._track : undefined,
        onFeatureUsage: this._trackFeatureUsage
      };
    }
  }, {
    key: "_getGlobalContext",
    value: function _getGlobalContext() {
      return {
        features: this._options.features,
        experiments: this._options.experiments,
        log: this.log,
        enabled: this._options.enabled,
        qaMode: this._options.qaMode,
        savedGroups: this._options.savedGroups,
        groups: this._options.groups,
        overrides: this._options.overrides,
        onExperimentEval: this._subscriptions.size > 0 ? this._fireSubscriptions : undefined,
        recordChangeId: this._recordChangedId,
        saveDeferredTrack: this._saveDeferredTrack,
        eventLogger: this._options.eventLogger
      };
    }
  }, {
    key: "_runAutoExperiment",
    value: function _runAutoExperiment(experiment, forceRerun) {
      var _this3 = this;
      var existing = this._activeAutoExperiments.get(experiment);

      // If this is a manual experiment and it's not already running, skip
      if (experiment.manual && !this._triggeredExpKeys.has(experiment.key) && !existing) return null;

      // Check if this particular experiment is blocked by options settings
      // For example, if all visualEditor experiments are disabled
      var isBlocked = this._isAutoExperimentBlockedByContext(experiment);
      if (isBlocked) {
        process.env.NODE_ENV !== "production" && this.log("Auto experiment blocked", {
          id: experiment.key
        });
      }
      var result;
      var trackingCall;
      // Run the experiment (if blocked exclude)
      if (isBlocked) {
        result = getExperimentResult(this._getEvalContext(), experiment, -1, false, "");
      } else {
        var _runExperiment2 = runExperiment(experiment, null, this._getEvalContext());
        result = _runExperiment2.result;
        trackingCall = _runExperiment2.trackingCall;
        this._fireSubscriptions(experiment, result);
      }

      // A hash to quickly tell if the assigned value changed
      var valueHash = JSON.stringify(result.value);

      // If the changes are already active, no need to re-apply them
      if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
        return result;
      }

      // Undo any existing changes
      if (existing) this._undoActiveAutoExperiment(experiment);

      // Apply new changes
      if (result.inExperiment) {
        var changeType = getAutoExperimentChangeType(experiment);
        if (changeType === "redirect" && result.value.urlRedirect && experiment.urlPatterns) {
          var url = experiment.persistQueryString ? mergeQueryStrings(this._getContextUrl(), result.value.urlRedirect) : result.value.urlRedirect;
          if (isURLTargeted(url, experiment.urlPatterns)) {
            this.log("Skipping redirect because original URL matches redirect URL", {
              id: experiment.key
            });
            return result;
          }
          this._redirectedUrl = url;
          var _this$_getNavigateFun = this._getNavigateFunction(),
            navigate = _this$_getNavigateFun.navigate,
            delay = _this$_getNavigateFun.delay;
          if (navigate) {
            if (isBrowser) {
              var _this$_options$maxNav;
              // Wait for the possibly-async tracking callback, bound by min and max delays
              Promise.all([].concat(_toConsumableArray(trackingCall ? [promiseTimeout(trackingCall, (_this$_options$maxNav = this._options.maxNavigateDelay) !== null && _this$_options$maxNav !== void 0 ? _this$_options$maxNav : 1000)] : []), [new Promise(function (resolve) {
                var _this3$_options$navig;
                return window.setTimeout(resolve, (_this3$_options$navig = _this3._options.navigateDelay) !== null && _this3$_options$navig !== void 0 ? _this3$_options$navig : delay);
              })])).then(function () {
                try {
                  navigate(url);
                } catch (e) {
                  console.error(e);
                }
              });
            } else {
              try {
                navigate(url);
              } catch (e) {
                console.error(e);
              }
            }
          }
        } else if (changeType === "visual") {
          var undo = this._options.applyDomChangesCallback ? this._options.applyDomChangesCallback(result.value) : this._applyDOMChanges(result.value);
          if (undo) {
            this._activeAutoExperiments.set(experiment, {
              undo: undo,
              valueHash: valueHash
            });
          }
        }
      }
      return result;
    }
  }, {
    key: "_undoActiveAutoExperiment",
    value: function _undoActiveAutoExperiment(exp) {
      var data = this._activeAutoExperiments.get(exp);
      if (data) {
        data.undo();
        this._activeAutoExperiments.delete(exp);
      }
    }
  }, {
    key: "_updateAllAutoExperiments",
    value: function _updateAllAutoExperiments(forceRerun) {
      var _this4 = this;
      if (!this._autoExperimentsAllowed) return;
      var experiments = this._options.experiments || [];

      // Stop any experiments that are no longer defined
      var keys = new Set(experiments);
      this._activeAutoExperiments.forEach(function (v, k) {
        if (!keys.has(k)) {
          v.undo();
          _this4._activeAutoExperiments.delete(k);
        }
      });

      // Re-run all new/updated experiments
      var _iterator2 = _createForOfIteratorHelper(experiments),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var exp = _step2.value;
          var result = this._runAutoExperiment(exp, forceRerun);

          // Once you're in a redirect experiment, break out of the loop and don't run any further experiments
          if (result !== null && result !== void 0 && result.inExperiment && getAutoExperimentChangeType(exp) === "redirect") {
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "_fireSubscriptions",
    value: function _fireSubscriptions(experiment, result) {
      var key = experiment.key;

      // If assigned variation has changed, fire subscriptions
      var prev = this._assigned.get(key);
      // TODO: what if the experiment definition has changed?
      if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
        this._assigned.set(key, {
          experiment: experiment,
          result: result
        });
        this._subscriptions.forEach(function (cb) {
          try {
            cb(experiment, result);
          } catch (e) {
            console.error(e);
          }
        });
      }
    }
  }, {
    key: "_recordChangedId",
    value: function _recordChangedId(id) {
      this._completedChangeIds.add(id);
    }
  }, {
    key: "_trackFeatureUsage",
    value: function _trackFeatureUsage(key, res) {
      // Only track a feature once, unless the assigned value changed
      var stringifiedValue = JSON.stringify(res.value);
      if (this._trackedFeatures[key] === stringifiedValue) return;
      this._trackedFeatures[key] = stringifiedValue;
      if (this._options.enableDevMode) {
        this.logs.push({
          featureKey: key,
          result: res,
          timestamp: Date.now().toString(),
          logType: "feature"
        });
      }

      // Fire user-supplied callback
      if (this._options.onFeatureUsage) {
        try {
          this._options.onFeatureUsage(key, res);
        } catch (e) {
          // Ignore feature usage callback errors
        }
      }
    }
  }, {
    key: "isOn",
    value: function isOn(key) {
      return this.evalFeature(key).on;
    }
  }, {
    key: "isOff",
    value: function isOff(key) {
      return this.evalFeature(key).off;
    }
  }, {
    key: "getFeatureValue",
    value: function getFeatureValue(key, defaultValue) {
      var value = this.evalFeature(key).value;
      return value === null ? defaultValue : value;
    }

    /**
     * @deprecated Use {@link evalFeature}
     * @param id
     */
    // eslint-disable-next-line
  }, {
    key: "feature",
    value: function feature(id) {
      return this.evalFeature(id);
    }
  }, {
    key: "evalFeature",
    value: function evalFeature(id) {
      return _evalFeature(id, this._getEvalContext());
    }
  }, {
    key: "log",
    value: function log(msg, ctx) {
      if (!this.debug) return;
      if (this._options.log) this._options.log(msg, ctx);else console.log(msg, ctx);
    }
  }, {
    key: "getDeferredTrackingCalls",
    value: function getDeferredTrackingCalls() {
      return Array.from(this._deferredTrackingCalls.values());
    }
  }, {
    key: "setDeferredTrackingCalls",
    value: function setDeferredTrackingCalls(calls) {
      var _this5 = this;
      this._deferredTrackingCalls = new Map(calls.filter(function (c) {
        return c && c.experiment && c.result;
      }).map(function (c) {
        return [_this5._getTrackKey(c.experiment, c.result), c];
      }));
    }
  }, {
    key: "fireDeferredTrackingCalls",
    value: function () {
      var _fireDeferredTrackingCalls = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this6 = this;
        var promises;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (this._options.trackingCallback) {
                _context14.next = 2;
                break;
              }
              return _context14.abrupt("return");
            case 2:
              promises = [];
              this._deferredTrackingCalls.forEach(function (call) {
                if (!call || !call.experiment || !call.result) {
                  console.error("Invalid deferred tracking call", {
                    call: call
                  });
                } else {
                  promises.push(_this6._track(call.experiment, call.result));
                }
              });
              this._deferredTrackingCalls.clear();
              _context14.next = 7;
              return Promise.all(promises);
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function fireDeferredTrackingCalls() {
        return _fireDeferredTrackingCalls.apply(this, arguments);
      }
      return fireDeferredTrackingCalls;
    }()
  }, {
    key: "setTrackingCallback",
    value: function setTrackingCallback(callback) {
      this._options.trackingCallback = callback;
      this.fireDeferredTrackingCalls();
    }
  }, {
    key: "setEventLogger",
    value: function setEventLogger(logger) {
      this._options.eventLogger = logger;
    }
  }, {
    key: "logEvent",
    value: function () {
      var _logEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(eventName, properties) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!this._destroyed) {
                _context15.next = 3;
                break;
              }
              console.error("Cannot log event to destroyed GrowthBook instance");
              return _context15.abrupt("return");
            case 3:
              if (this._options.enableDevMode) {
                this.logs.push({
                  eventName: eventName,
                  properties: properties,
                  timestamp: Date.now().toString(),
                  logType: "event"
                });
              }
              if (!this._options.eventLogger) {
                _context15.next = 15;
                break;
              }
              _context15.prev = 5;
              _context15.next = 8;
              return this._options.eventLogger(eventName, properties || {}, this._getUserContext());
            case 8:
              _context15.next = 13;
              break;
            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15["catch"](5);
              console.error(_context15.t0);
            case 13:
              _context15.next = 16;
              break;
            case 15:
              console.error("No event logger configured");
            case 16:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[5, 10]]);
      }));
      function logEvent(_x17, _x18) {
        return _logEvent.apply(this, arguments);
      }
      return logEvent;
    }()
  }, {
    key: "_getTrackKey",
    value: function _getTrackKey(experiment, result) {
      return result.hashAttribute + result.hashValue + experiment.key + result.variationId;
    }
  }, {
    key: "_saveDeferredTrack",
    value: function _saveDeferredTrack(data) {
      this._deferredTrackingCalls.set(this._getTrackKey(data.experiment, data.result), data);
    }
  }, {
    key: "_track",
    value: function () {
      var _track2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16(experiment, result) {
        var k;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              k = this._getTrackKey(experiment, result); // Make sure a tracking callback is only fired once per unique experiment
              if (!this._trackedExperiments.has(k)) {
                _context16.next = 3;
                break;
              }
              return _context16.abrupt("return");
            case 3:
              this._trackedExperiments.add(k);
              if (this._options.enableDevMode) {
                this.logs.push({
                  experiment: experiment,
                  result: result,
                  timestamp: Date.now().toString(),
                  logType: "experiment"
                });
              }
              if (this._options.trackingCallback) {
                _context16.next = 7;
                break;
              }
              return _context16.abrupt("return");
            case 7:
              _context16.prev = 7;
              _context16.next = 10;
              return this._options.trackingCallback(experiment, result);
            case 10:
              _context16.next = 15;
              break;
            case 12:
              _context16.prev = 12;
              _context16.t0 = _context16["catch"](7);
              console.error(_context16.t0);
            case 15:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this, [[7, 12]]);
      }));
      function _track(_x19, _x20) {
        return _track2.apply(this, arguments);
      }
      return _track;
    }()
  }, {
    key: "_getContextUrl",
    value: function _getContextUrl() {
      return this._options.url || (isBrowser ? window.location.href : "");
    }
  }, {
    key: "_isAutoExperimentBlockedByContext",
    value: function _isAutoExperimentBlockedByContext(experiment) {
      var changeType = getAutoExperimentChangeType(experiment);
      if (changeType === "visual") {
        if (this._options.disableVisualExperiments) return true;
        if (this._options.disableJsInjection) {
          if (experiment.variations.some(function (v) {
            return v.js;
          })) {
            return true;
          }
        }
      } else if (changeType === "redirect") {
        if (this._options.disableUrlRedirectExperiments) return true;

        // Validate URLs
        try {
          var current = new URL(this._getContextUrl());
          var _iterator3 = _createForOfIteratorHelper(experiment.variations),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var v = _step3.value;
              if (!v || !v.urlRedirect) continue;
              var url = new URL(v.urlRedirect);

              // If we're blocking cross origin redirects, block if the protocol or host is different
              if (this._options.disableCrossOriginUrlRedirectExperiments) {
                if (url.protocol !== current.protocol) return true;
                if (url.host !== current.host) return true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } catch (e) {
          // Problem parsing one of the URLs
          this.log("Error parsing current or redirect URL", {
            id: experiment.key,
            error: e
          });
          return true;
        }
      } else {
        // Block any unknown changeTypes
        return true;
      }
      if (experiment.changeId && (this._options.blockedChangeIds || []).includes(experiment.changeId)) {
        return true;
      }
      return false;
    }
  }, {
    key: "getRedirectUrl",
    value: function getRedirectUrl() {
      return this._redirectedUrl;
    }
  }, {
    key: "_getNavigateFunction",
    value: function _getNavigateFunction() {
      if (this._options.navigate) {
        return {
          navigate: this._options.navigate,
          delay: 0
        };
      } else if (isBrowser) {
        return {
          navigate: function navigate(url) {
            window.location.replace(url);
          },
          delay: 100
        };
      }
      return {
        navigate: null,
        delay: 0
      };
    }
  }, {
    key: "_applyDOMChanges",
    value: function _applyDOMChanges(changes) {
      if (!isBrowser) return;
      var undo = [];
      if (changes.css) {
        var s = document.createElement("style");
        s.innerHTML = changes.css;
        document.head.appendChild(s);
        undo.push(function () {
          return s.remove();
        });
      }
      if (changes.js) {
        var script = document.createElement("script");
        script.innerHTML = changes.js;
        if (this._options.jsInjectionNonce) {
          script.nonce = this._options.jsInjectionNonce;
        }
        document.head.appendChild(script);
        undo.push(function () {
          return script.remove();
        });
      }
      if (changes.domMutations) {
        changes.domMutations.forEach(function (mutation) {
          undo.push(mutate.declarative(mutation).revert);
        });
      }
      return function () {
        undo.forEach(function (fn) {
          return fn();
        });
      };
    }
  }, {
    key: "refreshStickyBuckets",
    value: function () {
      var _refreshStickyBuckets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17(data) {
        var ctx, docs;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!this._options.stickyBucketService) {
                _context17.next = 6;
                break;
              }
              ctx = this._getEvalContext();
              _context17.next = 4;
              return getAllStickyBucketAssignmentDocs(ctx, this._options.stickyBucketService, data);
            case 4:
              docs = _context17.sent;
              this._options.stickyBucketAssignmentDocs = docs;
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function refreshStickyBuckets(_x21) {
        return _refreshStickyBuckets.apply(this, arguments);
      }
      return refreshStickyBuckets;
    }()
  }]);
}();
export function prefetchPayload(_x22) {
  return _prefetchPayload.apply(this, arguments);
}
function _prefetchPayload() {
  _prefetchPayload = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18(options) {
    var instance;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          // Create a temporary instance, just to fetch the payload
          instance = new GrowthBook(options);
          _context18.next = 3;
          return refreshFeatures({
            instance: instance,
            skipCache: options.skipCache,
            allowStale: false,
            backgroundSync: options.streaming
          });
        case 3:
          instance.destroy();
        case 4:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _prefetchPayload.apply(this, arguments);
}